'use strict';

import 'angular';


export default function () {
  return function (incident, labelName) {
    if (!labelName) {
      return false;
    }
    if (!angular.isArray(labelName)) {
      labelName = [labelName];
    }
    if (incident && incident.hasOwnProperty('labels')) {
      for (const incidentLabel of incident.labels) {
        for (const targetLabel of labelName) {
          if (incidentLabel.name.toLowerCase() == targetLabel.toLowerCase()) {
            return true;
          }
        }
      }
    }
    return false;
  }
}
